import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const assignAdminSensorOrderDevices = async (orderId, deviceIds) => {
  const request = await createSignedPatchRequest({
    apiPath: `admin/renolog/sensor-orders/${orderId}/assign-devices`,
    body: { deviceIds },
    //isLocalApiRequest: true,
  });
  const response = await axios(request);
  return response.data;
};
